export { ReactComponent as VideoObject } from './svgs/video-object.svg';
